import { user_bind_info,lessonOpenInfo } from '@/api/mycenter_studyabroad'

const state = {
  userAbroadData: {},
  lessonOpenInfo: {},
  userAbroadDataState:"loading"
}

const mutations = {
  UPDATE_USER_ABROAD_INFO: (state,data) => {
    state.userAbroadData = data
  },
  UPDATE_USER_ABROAD_STATE:(state,data) => {
    state.userAbroadDataState = data
  },
  UPDATE_USERABROAD_LESSON_OPEN_INFO: (state, data) => {
    state.lessonOpenInfo = data
  },
}

const actions = {
  geUserAbroadData({ commit},userId) {
    return new Promise((resolve, reject) => {
      user_bind_info({ user_id: userId }).then(response => {
        const { data } = response
        commit('UPDATE_USER_ABROAD_INFO', data)
        commit('UPDATE_USER_ABROAD_STATE', "normal")
        resolve()
      }).catch(error => {
        commit('UPDATE_USER_ABROAD_STATE', "error")
        reject(error)
      })
      lessonOpenInfo({ user_id: userId }).then((response) => {
        commit("UPDATE_USERABROAD_LESSON_OPEN_INFO", response.data)
      }).catch(error => {

      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/api/userAbroad.js